import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormListComponent } from '../components/utils/form-list/form-list.component';

@Component({
    selector: 'app-user-list',
    imports: [CommonModule, FormListComponent],
    template: `<app-form-list form="User" header="Users" detailUrl="/admin/users"> </app-form-list>`,
    styles: []
})
export class UserListComponent {}
